export const updateName = (name) => (dispatch) => {
  dispatch({
    type: 'UPDATE_SKATEPARK_CHECKIN_NAME',
    payload: name
  });
};

export const updateSelected = (id) => (dispatch, getState) => {
  dispatch({
    type: 'UPDATE_SKATEPARK_CHECKIN_SELECTED',
    payload: getState().skatepark.checkin.selected === id ? 0 : id
  });
};

export const clearSelection = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_SKATEPARK_CHECKIN_SELECTED'
  });
};
